'use client'

import { HeartFilled16 } from '@vinted/monochrome-icons'
import { ColorCode, Icon, Image } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  landingPageEvent,
  HoVLandingPageEvent,
  HovClosetSectionProductCardModel,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

const HoVClosetSectionProductCard = ({
  title,
  thumbnailUrl,
  productUrl,
  testId,
}: HovClosetSectionProductCardModel) => {
  const { track } = useTracking()

  const handleCardClick = async () =>
    track(
      landingPageEvent({
        event: HoVLandingPageEvent.ClosetProductCardCtaClick,
        targetDetails: productUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <article className="hov__closet-section-product-card">
      <a href={productUrl} onClick={handleCardClick}>
        <div className="hov__closet-section-product-card-image">
          {thumbnailUrl && (
            <Image
              src={thumbnailUrl}
              loading="lazy"
              scaling={Image.Scaling.Cover}
              testId={testId}
            />
          )}
          <div className="hov__closet-section-fave-icon">
            <Icon name={HeartFilled16} color={ColorCode.WarningMedium} />
          </div>
        </div>
        <h3 className="hov__closet-section-product-card-title">{title}</h3>
      </a>
    </article>
  )
}

export default HoVClosetSectionProductCard
